import { Trans, useTranslation } from 'react-i18next';
import AirplaneIcon from '@/assets/icons/our-identity-1.svg?react';
import BeachIcon from '@/assets/icons/our-identity-2.svg?react';
import StarsIcon from '@/assets/icons/our-identity-3.svg?react';
import GuideIcon from '@/assets/icons/our-identity-4.svg?react';
import styles from './OurIdentity.module.scss';

interface IProps {
    isAloyPlan?: boolean;
}

const OurIdentity = ({ isAloyPlan = false }: IProps) => {
    const { t } = useTranslation();

    const items = [
        {
            image: <AirplaneIcon style={{ width: 84, aspectRatio: '21 / 23' }} />,
            name: isAloyPlan ? t('personalization') : t('ourIdentityItem1Title'),
            description: isAloyPlan ? t('weKnowEveryTravellerIsUnique') : t('ourIdentityItem1Desc'),
        },
        {
            image: <BeachIcon style={{ width: 75, aspectRatio: '75 / 76' }} />,
            name: isAloyPlan ? t('stressFree') : t('ourIdentityItem2Title'),
            description: isAloyPlan ? t('ourAllInOnePlatform') : t('ourIdentityItem2Desc'),
        },
        {
            image: <StarsIcon style={{ width: 78, aspectRatio: '39 / 35' }} />,
            name: isAloyPlan ? t('connection') : t('ourIdentityItem3Title'),
            description: isAloyPlan ? t('travelIsBetterTogether') : t('ourIdentityItem3Desc'),
        },
        {
            image: <GuideIcon style={{ width: 73, aspectRatio: '1 / 1' }} />,
            name: isAloyPlan ? t('excellentService') : t('ourIdentityItem4Title'),
            description: isAloyPlan ? t('weAreWithYouInEveryStep') : t('ourIdentityItem4Desc'),
        },
    ];

    return (
        <section className={styles.sectionContainer}>
            <h2 className={styles.sectionTitle}>
                <Trans i18nKey="ourIdentity">
                    Our <span>identity</span>
                </Trans>
            </h2>
            <div className={styles.itemsContainer}>
                {items.map((item) => (
                    <div className={styles.item} key={item.name}>
                        <div className={styles.itemImage}>{item.image}</div>
                        <div className={styles.itemContent}>
                            <p className={styles.itemName}>{item.name}</p>
                            <p className={styles.itemDescription}>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default OurIdentity;
